{
  "name": "@sveltia/cms",
  "version": "0.152.0",
  "description": "Sveltia CMS is a modern, lightweight, Git-based headless content management system.",
  "keywords": [
    "cms",
    "content-management-system"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/sveltia/sveltia-cms"
  },
  "license": "MIT",
  "type": "module",
  "scripts": {
    "build": "vite build",
    "build:watch": "vite build --watch",
    "check": "pnpm run '/^check:.*/'",
    "check:audit": "pnpm audit",
    "check:cspell": "cspell --no-progress",
    "check:eslint": "eslint .",
    "check:imports": "node scripts/find-unused-imports.js",
    "check:oxlint": "oxlint .",
    "check:prettier": "prettier --check .",
    "check:stylelint": "stylelint '**/*.{css,scss,svelte}'",
    "check:svelte": "svelte-check",
    "dev": "vite",
    "format": "prettier --write .",
    "prepublishOnly": "vite build",
    "preview": "vite preview",
    "test": "NODE_OPTIONS=--no-experimental-webstorage vitest run",
    "test:coverage": "NODE_OPTIONS=--no-experimental-webstorage vitest run --coverage",
    "test:watch": "NODE_OPTIONS=--no-experimental-webstorage vitest"
  },
  "dependencies": {
    "@jsquash/webp": "^1.5.0",
    "@lexical/markdown": "^0.42.0",
    "@sindresorhus/transliterate": "^2.3.1",
    "@sveltia/ui": "^0.35.6",
    "@sveltia/utils": "^0.9.3",
    "create-react-class": "^15.7.0",
    "dayjs": "^1.11.20",
    "deepmerge": "^4.3.1",
    "exifr": "^7.1.3",
    "fast-deep-equal": "^3.1.3",
    "flat": "^6.0.1",
    "immutable": "^5.1.5",
    "isomorphic-dompurify": "^3.7.1",
    "leaflet": "^1.9.4",
    "lexical": "^0.42.0",
    "marked": "^17.0.5",
    "marked-bidi": "^1.0.14",
    "mime": "^4.1.0",
    "parse-entities": "^4.0.2",
    "pdfjs-dist": "^5.6.205",
    "qrcode": "^1.5.4",
    "react": "^19.2.4",
    "react-dom": "^19.2.4",
    "sanitize-filename": "^1.6.4",
    "smol-toml": "^1.6.1",
    "svelte-i18n": "^4.0.1",
    "svgo": "^4.0.1",
    "terra-draw": "^1.27.0",
    "terra-draw-leaflet-adapter": "1.0.3",
    "turndown": "^7.2.2",
    "yaml": "^2.8.3"
  },
  "devDependencies": {
    "@sveltejs/vite-plugin-svelte": "^7.0.0",
    "@types/leaflet": "^1.9.21",
    "@types/node": "^25.5.0",
    "@types/qrcode": "^1.5.6",
    "@types/react": "^19.2.14",
    "@types/react-dom": "^19.2.3",
    "@vitest/coverage-v8": "^4.1.2",
    "cspell": "^9.7.0",
    "eslint": "^9.39.4",
    "eslint-config-airbnb-extended": "^3.0.1",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsdoc": "^62.8.1",
    "eslint-plugin-package-json": "^0.91.1",
    "eslint-plugin-svelte": "^3.16.0",
    "eslint-plugin-unused-imports": "^4.4.1",
    "globals": "^17.4.0",
    "oxlint": "^1.58.0",
    "postcss": "^8.5.8",
    "postcss-html": "^1.8.1",
    "prettier": "^3.8.1",
    "prettier-plugin-svelte": "^3.5.1",
    "sass": "^1.98.0",
    "stylelint": "^17.6.0",
    "stylelint-config-recommended-scss": "^17.0.0",
    "stylelint-scss": "^7.0.0",
    "svelte": "^5.55.1",
    "svelte-check": "^4.4.6",
    "svelte-preprocess": "^6.0.3",
    "ts-json-schema-generator": "^2.9.0",
    "typescript": "^5.9.3",
    "vite": "^8.0.3",
    "vitest": "^4.1.2"
  },
  "publishConfig": {
    "directory": "package",
    "access": "public",
    "provenance": true
  }
}
